import { ContactListContext } from "context-providers/ContactListManager";
import { useContext } from "react";

export default function useSyncContacts() {
  const { isSyncing, syncContacts, checkSync } = useContext(ContactListContext);
  return { isSyncing, syncContacts, checkSync };
}
